/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomCard from '../../../../common/components/CustomCard';
import { Box } from '@mui/material';
import LeaveEligibilityTile from '../../../../common/components/LeaveEligibilityTile/LeaveEligibilityTile';
import _ from 'lodash';
import LeaveEligibilityModalController from '../../../../common/Modals/Leaves/LeaveEligibility/LeaveEligibilityModalController';
import Loader from '../../../../common/Lottifiers/Loader/Loader';

interface propsType {
  leaveData: any;
  isLoading: boolean;
  trans?: any;
}
const LeaveEligibilityPresenter: React.FC<propsType> = ({
  leaveData,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <CustomCard
        cardSize={{ card_title: trans('Leaves Eligibility') }}
        cardWidth="auto"
        cardHeight="650px"
        showPadding={true}
      >
        <Box style={{ marginBottom: '24px' }} />

        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <>
            <div>
              {_.map(leaveData, (leave: any) => {
                return (
                  <div>
                    <LeaveEligibilityTile
                      leaveName={leave?.leave_type?.name}
                      totalLeaves={
                        Number.isInteger(leave?.entitlement)
                          ? leave?.entitlement
                          : leave?.entitlement.toFixed('1')
                      }
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </CustomCard>

      {/* Leave advance Modal */}

      {openModal && (
        <LeaveEligibilityModalController
          trans={trans}
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};

export default LeaveEligibilityPresenter;
